import * as L from 'leaflet';
import 'leaflet-rotatedmarker';

(window as any).L = L;

export default L;
